(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-collection-directory"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ai-collection-directory').forEach((section) => {
    const input = section.querySelector('[data-collection-search]');
    const cards = Array.from(section.querySelectorAll('[data-collection-card]'));
    const count = section.querySelector('[data-result-count]');
    const empty = section.querySelector('[data-empty-message]');

    const update = () => {
      const query = input.value.trim().toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const matches = !query || card.dataset.searchText.includes(query);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      count.textContent = `${visible} collection${visible === 1 ? '' : 's'} shown`;
      empty.hidden = visible !== 0;
    };

    input.addEventListener('input', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
